module.exports = __webpack_public_path__ + "front/img/register-login-kv.303c9102.png";